module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms02_en.9cf756ab3bcbb650ab778f7a1c45e0ad.png";